import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Modal from "../modals/Modal"; // Adjust the import path
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import { postData } from "../../../services"; // Adjust the import path
import { errorStyles, confimationStyles } from "../../../assets/styles/toast"; // Adjust paths

const TeamDropdownModal = ({ isOpen, onClose, onSubmit, refetchTeamList }) => {
  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const res = await postData({
        endpoint: "Team/createTeam", 
        data: { name: values.name,
            team_lead_id: cookies.euid,
         },
        token: cookies.e_t,
      });

      if (res && res.data) {
        toast.success("Team Created", { style: confimationStyles });
        const newTeam = {
          value: res.data.data.team_id, 
          label: values.name,
        };
        onSubmit(newTeam);
        refetchTeamList();
        resetForm();
      }
    } catch (err) {
      toast.error("Team Creation Failed", { style: errorStyles });
      console.error(err);
    } finally {
      setIsSubmitting(false);
      onClose();
    }
  };

  return (
    <Modal isActive={isOpen} onClose={onClose} title="Add New Team">
      <Formik
        initialValues={{ name: "" }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Team name is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({ errors }) => (
          <Form>
            <div className="form-group">
              <label className="required-field">Team Name</label>
              <Field
                name="name"
                className={`${errors.name ? "is-invalid" : ""}`}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Creating..." : "Create Team"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default TeamDropdownModal;